// JavaScript optimisé
document.addEventListener("DOMContentLoaded", () => {
	// Sélectionne tous les éléments avec la classe .has-typing-animation
	const typingElements = document.querySelectorAll(".has-typing-animation");

	// Nous conservons la détection tactile pour le débogage, mais n'en tenons plus compte
	const isTouchDevice = window.matchMedia("(hover: none)").matches;

	// Sur mobile, nous appliquons quand même l'animation mais gardons une classe pour référence
	if (isTouchDevice) {
		typingElements.forEach((element) => {
			element.classList.add("touch-device");
		});
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Ajoute la classe visible sans délai
					entry.target.classList.add("visible");
				} else {
					// Réinitialise l'élément lorsqu'il n'est plus visible
					entry.target.classList.remove("visible");
				}
			});
		},
		{
			threshold: 0.1,
			rootMargin: "20px 0px",
		}
	);

	typingElements.forEach((element) => {
		// Évite de retraiter les éléments déjà traités
		if (element.getAttribute("data-processed") === "true") return;

		// Sauvegarde le contenu HTML original
		const originalHTML = element.innerHTML.trim();

		// Divise le contenu en mots tout en préservant les balises HTML
		const processedHTML = processHTML(originalHTML);

		// Met à jour l'élément avec le contenu traité
		element.innerHTML = processedHTML;

		// Marque l'élément comme traité
		element.setAttribute("data-processed", "true");

		// Observe l'élément
		observer.observe(element);
	});
});

// Fonction pour traiter le HTML tout en préservant les balises
function processHTML(html) {
	// Crée un conteneur temporaire
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = html;

	// Traite les nœuds de manière récursive
	processNodeRecursively(tempDiv);

	// Optimisation: limiter le nombre de mots pour les appareils à faible puissance
	const isTouchDevice = window.matchMedia("(hover: none)").matches;
	if (isTouchDevice) {
		limitWordCount(tempDiv, 30); // Limiter à 30 mots maximum sur mobile pour les performances
	}

	return tempDiv.innerHTML;
}

function processNodeRecursively(node) {
	// Parcours tous les nœuds enfants
	for (let i = 0; i < node.childNodes.length; i++) {
		const child = node.childNodes[i];

		// Si c'est un nœud texte avec du contenu
		if (child.nodeType === 3 && child.textContent.trim()) {
			// Divise le texte en mots
			const words = child.textContent.trim().split(/\s+/);
			const fragment = document.createDocumentFragment();

			words.forEach((word, index) => {
				if (word) {
					// Crée un span pour chaque mot
					const wordSpan = document.createElement("span");

					// Ajoute la classe 'word', et si c'est le premier mot dans son parent,
					// ajoute aussi la classe 'first-word'
					wordSpan.className = "word";
					if (index === 0) {
						wordSpan.classList.add("first-word");
					}

					wordSpan.textContent = word;

					fragment.appendChild(wordSpan);

					// Ajoute un espace après chaque mot sauf le dernier
					if (index < words.length - 1) {
						fragment.appendChild(document.createTextNode(" "));
					}
				}
			});

			// Remplace le nœud texte par les spans
			node.replaceChild(fragment, child);

			// Ajuste l'index car on a modifié le DOM
			i += words.length - 1;
		}
		// Si c'est un élément (pas un br, script, style)
		else if (
			child.nodeType === 1 &&
			!["BR", "SCRIPT", "STYLE"].includes(child.nodeName)
		) {
			// Traite récursivement les enfants
			processNodeRecursively(child);
		}
	}
}

// Fonction pour limiter le nombre de mots animés (pour les appareils mobiles)
function limitWordCount(node, maxWords) {
	const words = node.querySelectorAll(".word");
	let wordCount = 0;

	words.forEach((word) => {
		wordCount++;
		if (wordCount > maxWords) {
			// Au-delà du maximum, supprime la classe .word pour éviter l'animation
			// mais garde le texte visible
			word.classList.remove("word");
			word.classList.add("no-animation");
		}
	});
}
